/**
 * GraphQL Queries for Task Previews
 *
 * @module pages/tasks/graphql/queries
 */

import { gql } from '@apollo/client';

/**
 * Minimal critique/comment query for task previews
 * Fetches the comment content and associated photo
 */
export const GET_CRITIQUE_PREVIEW = gql`
  query GetCritiquePreview($id: ID!) {
    critique(id: $id) {
      id
      globalId
      content
      photoId
      photo {
        id
        title
        variants {
          id
          variantType
          storageUrl
          publicUrl
          width
          height
        }
      }
    }
  }
`;

/**
 * Minimal critique session query for task previews
 * Only fetches what we need: heroPhoto for display
 */
export const GET_CRITIQUE_SESSION_PREVIEW = gql`
  query GetCritiqueSessionPreview($id: ID!) {
    critiqueSession(id: $id) {
      id
      globalId
      title
      collection {
        id
        title
        heroPhotoId
        heroPhoto {
          id
          variants {
            id
            variantType
            storageUrl
            publicUrl
            width
            height
          }
        }
        systemHeroPhoto {
          id
          variants {
            id
            variantType
            storageUrl
            publicUrl
            width
            height
          }
        }
        items(limit: 1) {
          items {
            id
            photo {
              id
              variants {
                id
                variantType
                storageUrl
                publicUrl
                width
                height
              }
            }
          }
        }
      }
    }
  }
`;
